var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutubeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#FF0000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6752 8.6991C18.5185 8.11001 18.0549 7.64529 17.4651 7.48601C16.3988 7.2002 12.1202 7.2002 12.1202 7.2002C12.1202 7.2002 7.84388 7.2002 6.77534 7.48601C6.18775 7.6431 5.7242 8.10783 5.56533 8.6991C5.28024 9.7682 5.28024 12.0002 5.28024 12.0002C5.28024 12.0002 5.28024 14.2322 5.56533 15.3013C5.72202 15.8904 6.18557 16.3551 6.77534 16.5144C7.84388 16.8002 12.1202 16.8002 12.1202 16.8002C12.1202 16.8002 16.3988 16.8002 17.4651 16.5144C18.0527 16.3573 18.5163 15.8926 18.6752 15.3013C18.9602 14.2322 18.9602 12.0002 18.9602 12.0002C18.9602 12.0002 18.9602 9.7682 18.6752 8.6991Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7535 14.0577L14.3074 12.0002L10.7535 9.94274V14.0577Z",
    fill: "#FF0000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtube-icon.2ed0522cedd58763ea09e81638d9518a.svg";
export { ForwardRef as ReactComponent };